const TOGGLE_SIZES = ["small", "large"];

export default TOGGLE_SIZES;



// WEBPACK FOOTER //
// ./src/components/Input/Toggle/constants.js